import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '@/features/auth/hooks/useAuth';
import { useLanguage } from '@/shared/hooks/useLanguage';
import { UserAvatarMenu } from './UserAvatarMenu';

export function UserAuthButton() {
  const { t } = useTranslation();
  const { isRTL } = useLanguage();
  const { user, isLoading, isAuthenticated, signOut } = useAuth();

  if (isLoading) return null;

  const positionClass = isRTL ? 'left-4' : 'right-4';

  if (isAuthenticated && user) {
    return (
      <div className={`fixed top-4 z-50 ${positionClass}`}>
        <UserAvatarMenu user={user} onSignOut={signOut} />
      </div>
    );
  }

  return (
    <Link
      to="/auth/signin"
      className={`fixed top-4 z-50 bg-gradient-to-br from-emerald-500 to-teal-600 text-white px-4 py-2 rounded-full text-sm font-medium hover:from-emerald-400 hover:to-teal-500 transition-all ${positionClass}`}
    >
      {t('auth.signInLink')}
    </Link>
  );
}
